module.exports = __webpack_public_path__ + "img/banana-pudding.8b3d378a.jpg";